import { ENVIRONMENT } from "@/config/env";

/**
 * T3: blog-cms exists on dev only. Only the exact production string disables it, which matches
 * the CI build of `prod`, so a production bundle can never mount `/blog-cms` while prod has no
 * editor and the api answers 503 there. The run that ships blog-cms to production drops this gate.
 */
export function isBlogCmsEnvironment(environment: string): boolean {
  return environment.trim() !== "production";
}

export const BLOG_CMS_ENABLED: boolean = isBlogCmsEnvironment(ENVIRONMENT);
